import { render, staticRenderFns } from "./WishlistCard.vue?vue&type=template&id=4f6e72cf&"
import script from "./WishlistCard.vue?vue&type=script&lang=js&"
export * from "./WishlistCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports